import { createAPIService } from './api.service';

export const USER_ENDPOINT = '/user/api/v2/admin/users';

const service = createAPIService(USER_ENDPOINT);

// endpoints
service.getUsers = async params =>
  (await service.get('', { params: params })).data;

service.getUser = async id => (await service.get(`/${id}`)).data;

service.createUser = async user =>
  (
    await service.post('', {
      ...user,
      status: 'ACTIVE',
    })
  ).data;

service.updateUser = async (id, group) =>
  (await service.patch(`/${id}`, group)).data;

service.deleteUser = async id => (await service.delete(`/${id}`)).data;

// policies
service.getUserPolicies = async (userId, params) =>
  (await service.get(`/${userId}/policies`, { params: params })).data;

service.addUserPolicies = async (userId, policyIds) =>
  (await service.post(`/${userId}/policies`, policyIds)).data;

service.deleteUserPolicies = async (userId, policyIds) =>
  (await service.delete(`/${userId}/policies/?ids=${policyIds.join()}`)).data;

// User permissions
service.getUserPermissions = async (id, params) =>
  (await service.get(`/${id}/permissions/`, { params: params })).data;

service.addUserPermission = async (id, permissions) =>
  (await service.post(`/${id}/permissions`, permissions)).data;

service.deleteUserPermission = async (id, permissions) =>
  (await service.delete(`/${id}/permissions/?ids=${permissions.join()}`)).data;

// User roles
service.getUserRoles = async (userId, params) =>
  (await service.get(`/${userId}/roles`, { params: params })).data;

service.addUserRoles = async (userId, roleIds) =>
  (await service.post(`/${userId}/roles`, roleIds)).data;

service.deleteUserRoles = async (userId, roleIds) =>
  (await service.delete(`/${userId}/roles/?ids=${roleIds.join()}`)).data;

// User groups
service.getUserGroups = async (userId, params) =>
  (await service.get(`/${userId}/user-groups`, { params: params })).data;

service.getUserOrganizations = async userId =>
  (await service.get(`/${userId}/organizations`)).data;

// Update user's organizations (replace associations)
service.updateUserOrganizations = async (userId, organizations) =>
  (await service.put(`/${userId}/organizations`, organizations)).data;

export default service;
